"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSettingsError = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

var _basic = _interopRequireDefault(require("./_basic"));

var _error = require("./error");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AccountSettingsError =
/*#__PURE__*/
function (_BasicError) {
  (0, _inherits2.default)(AccountSettingsError, _BasicError);

  /**
   * @constructor
   */
  function AccountSettingsError(error, data) {
    (0, _classCallCheck2.default)(this, AccountSettingsError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AccountSettingsError).call(this, 'AccountSettings API Error', error, data));
  }

  return AccountSettingsError;
}(_error.BasicError);

exports.AccountSettingsError = AccountSettingsError;

var AccountSettings =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(AccountSettings, _BasicApi);

  /**
   * @constructor
   */
  function AccountSettings(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        accountId = _ref.accountId;
    (0, _classCallCheck2.default)(this, AccountSettings);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AccountSettings).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.sdkApiUrl = sdkApiUrl;
    _this.accountId = accountId;
    _this.axios = _this._createAxios();
    return _this;
  }
  /**
   * Get all settings for Account
   * @async
   */


  (0, _createClass2.default)(AccountSettings, [{
    key: "getAllSettings",
    value: function () {
      var _getAllSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._callApi({
                  method: 'get'
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllSettings() {
        return _getAllSettings.apply(this, arguments);
      }

      return getAllSettings;
    }()
    /**
     * Get a setting for Account by key
     *
     * @param {String} key - setting key
     * @async
     */

  }, {
    key: "getSettingsByKey",
    value: function () {
      var _getSettingsByKey = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(key) {
        var _ref2, value;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._callApi({
                  method: 'get',
                  path: "/".concat(encodeURIComponent(key)),
                  errorData: {
                    key: key
                  }
                });

              case 2:
                _ref2 = _context2.sent;
                value = _ref2.value;
                return _context2.abrupt("return", value);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSettingsByKey(_x) {
        return _getSettingsByKey.apply(this, arguments);
      }

      return getSettingsByKey;
    }()
    /**
     * Set all settings for Account
     *
     * @param {Object} data - settings object {key : value}
     * @async
     */

  }, {
    key: "setAllSettings",
    value: function () {
      var _setAllSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(data) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._callApi({
                  method: 'post',
                  payload: data
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setAllSettings(_x2) {
        return _setAllSettings.apply(this, arguments);
      }

      return setAllSettings;
    }()
    /**
     * Set account settings by key
     *
     * @param {String} key - setting key
     * @param {Object} data - setting data
     * @async
     */

  }, {
    key: "setSettingsByKey",
    value: function () {
      var _setSettingsByKey = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(key, data) {
        var _ref3, value;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._callApi({
                  method: 'post',
                  path: "/".concat(encodeURIComponent(key)),
                  payload: data,
                  errorData: {
                    key: key
                  }
                });

              case 2:
                _ref3 = _context4.sent;
                value = _ref3.value;
                return _context4.abrupt("return", value);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setSettingsByKey(_x3, _x4) {
        return _setSettingsByKey.apply(this, arguments);
      }

      return setSettingsByKey;
    }()
    /**
     * Delete account settings by key
     *
     * @param {String} key - setting key
     * @async
     */

  }, {
    key: "deleteSettingsByKey",
    value: function () {
      var _deleteSettingsByKey = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(key) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._callApi({
                  method: 'delete',
                  path: "/".concat(encodeURIComponent(key)),
                  errorData: {
                    key: key
                  }
                });

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteSettingsByKey(_x5) {
        return _deleteSettingsByKey.apply(this, arguments);
      }

      return deleteSettingsByKey;
    }()
  }, {
    key: "_callApi",
    value: function () {
      var _callApi2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref4) {
        var method, _ref4$path, path, payload, queryParams, _ref4$errorData, errorData, _ref5, headers, _ref6, responseBody;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                method = _ref4.method, _ref4$path = _ref4.path, path = _ref4$path === void 0 ? '' : _ref4$path, payload = _ref4.payload, queryParams = _ref4.queryParams, _ref4$errorData = _ref4.errorData, errorData = _ref4$errorData === void 0 ? {} : _ref4$errorData;
                _context6.next = 3;
                return this.getHeaders();

              case 3:
                _ref5 = _context6.sent;
                headers = _ref5.headers;
                _context6.prev = 5;
                _context6.next = 8;
                return this.axios({
                  method: method,
                  url: path,
                  data: JSON.stringify(payload),
                  params: queryParams,
                  headers: headers
                });

              case 8:
                _ref6 = _context6.sent;
                responseBody = _ref6.data;
                return _context6.abrupt("return", responseBody);

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](5);
                throw new AccountSettingsError(_context6.t0, _objectSpread({
                  statusCode: _lodash.default.get(_context6.t0, 'response.status')
                }, errorData));

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 13]]);
      }));

      function _callApi(_x6) {
        return _callApi2.apply(this, arguments);
      }

      return _callApi;
    }()
  }, {
    key: "_createAxios",
    value: function _createAxios() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          baseUrl = _ref7.baseUrl;

      var settingsUrl = "".concat(this.sdkApiUrl).concat(this.accountId ? "/accounts/".concat(encodeURIComponent(this.accountId)) : '', "/account-settings");
      return _axios.default.create({
        baseURL: baseUrl || settingsUrl // timeout : 10000

      });
    }
  }]);
  return AccountSettings;
}(_basic.default);

var _default = AccountSettings;
exports.default = _default;